<script setup>
import { computed } from 'vue';
import { useRoute } from 'vue-router';
import ExtensionSlot from './ExtensionSlot.vue';
import { useExtensionSettingsPages } from './useExtensionSettingsPages';

const route = useRoute();
const { pages, context } = useExtensionSettingsPages();
const page = computed(() =>
  pages.value.find(item => item.id === route.params.extensionPageId)
);
</script>

<template>
  <section class="w-full">
    <ExtensionSlot
      v-if="page"
      :key="page.id"
      :name="page.slot"
      :context="context"
    />
    <p v-else class="text-sm text-n-slate-11" role="status">
      {{ $t('EXTENSION_SETTINGS.UNAVAILABLE') }}
    </p>
  </section>
</template>
